<template>
    <div>
      <b-overlay
      :show="loading"
      rounded="lg"
    >
      <b-row>
        <b-col
          cols="12"
          md="2"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <!-- <b-button
              variant="primary"
              class="mb-1"
              @click="generate_all_teacher()"
            >
              <span class="text-nowrap">匯出全部</span>
            </b-button> -->
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
      </b-col>
      <b-col
          cols="12"
          md="3"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <v-select
                v-model="teacher_id"
                label="label"
                :clearable="false"
                :options="teachers"
                class="mb-1 mr-1"
                />
      </b-col>
        <b-col
          cols="12"
          md="4"
        >    
          <div class="d-flex align-items-center justify-content-end">           
            <flat-pickr
            v-model="rangeDate"
            class="form-control mb-1 mr-1"
            :config="{ mode: 'range'}"
          />
            <b-button
              variant="primary"
              class="mb-1"
              @click="exportToExcel()"
            >
              <span class="text-nowrap">Export</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
       
      >
        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="success"
          :statistic="stats.total_class"
          statistic-title="總班數"
        />
      </b-col>
      <b-col
      
      >
        <statistic-card-horizontal
          icon="UsersIcon"
          :statistic="stats.total_attend"
          statistic-title="出席總人次"
        />
      </b-col>
      <b-col
       
      >
        <statistic-card-horizontal
          icon="GithubIcon"
          color="warning"
          :statistic="stats.trial + ' ('+stats.trial_success+')'"
          statistic-title="試堂人數"
        />
      </b-col>
      <b-col
       
      >
        <statistic-card-horizontal
          icon="PenToolIcon"
          color="danger"
          :statistic="stats.short_course"
          statistic-title="工作坊總人次"
        />
      </b-col>
      <b-col
       
      >
        <statistic-card-horizontal
          icon="AlertOctagonIcon"
          color="warning"
          :statistic="stats.markup"
          statistic-title="補堂總人次"
        />
      </b-col>
    </b-row>
      <!-- table -->
      <b-table
        ref="selectableTable"
        :items="items"
        :fields="fields"
        responsive
        striped
        class="mb-0"
        @row-selected="onRowSelected"
      >
        <template #cell(status_number)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell()="data">
            <span v-if="data.value != '0'">{{ data.value }}</span>
            <span v-if="data.value == 0" style="color:#ddd;">{{ data.value }}</span>
        </template>
        <template #cell(attend)="data">
          <b-badge variant="primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.status == 'VOID'" style="color:red;"><b> -{{data.item.amount}}</b></span>
          <span v-if="data.item.status == 'ACTIVE'">{{data.item.amount}}</span>
        </template>
      </b-table>
      </b-overlay>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
  import moment from 'moment'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BOverlay, BTable, BAvatar, BCard, BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
  export default {
    components: {
      moment,
      BOverlay,
      flatPickr,
      BCard,
      StatisticCardHorizontal,
      BTable,
      ToastificationContent,
      BModal, VBModal,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        iframe_src : '//rb.cloudedu.pro/invoice.php',
        rangeDate: null,
        searchString: null,
        type:'all',
        test_string : null,
        headerTitle: ['CLASS ID', 'CENTER','DATETIME', 'GRADE', 'ATTEND','TRIAL','SHORT_COURSE','ABSENT'],
        headerVal: ['id', 'code', 'datetime', 'grade','attend','trial','short_course','absent'],
        teachers:[],
        centerOptions: [],
        isAddNewMemberSidebarActive: false,
        searchString: null,
        perPage: 10,
        startRow: 1,
        stats:{
            total_attend:0,
            trial:0,
            trial_success:0,
            short_course:0,
            markup:0,
            total_class:0,
        },
        teacher_id:null,
        endRow: 10,
        totalAmount: 0,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        loading:false,
        currentPage: 1,
        fields: [{ key: 'id', label: 'CLASS ID' }, { key: 'code', label: 'CENTER' },{ key: 'datetime', label: 'Date Time' },{ key: 'grade', label: 'Grade' }, { key: 'attend', label: 'attend' },{ key: 'regular', label: 'regular' },  { key: 'trial', label: 'trial' }, { key: 'short_course', label: 'short course' }, { key: 'markup', label: 'markup' },  { key: 'absent', label: 'absent' }],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },
    watch: {
      teacher_id: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      rangeDate : {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
      this.get_staffs()
      //this.get_data()
    },
    methods: {
      generate_all_teacher() {
      var teachers = [];
        this.loading = true
        this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/?role=TEACHER',{})
          .then(res => {
            teachers = res.data


              teachers.forEach(function(teacher, index) {
                setTimeout(function(){
                  console.log(teacher.value)
                }, 1000 * (index + 1));
               })


          })
          this.loading = false
      },
    get_staffs() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/',{})
          .then(res => {
            this.teachers = res.data
          })
      },
      send() {
        this.$http.post(process.env.VUE_APP_API_BASE+'/transaction/'+this.selected.id+'/send/',{})
          .then(res => {
            this.$refs['my-modal'].hide()
          })
      },
      exportToExcel() {
        console.log(this.items)
        console.log(this.headerTitle)
        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(this.headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: 'staff_'+this.teacher_id.label,
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            // Add col name which needs to be translated
            // if (j === 'timestamp') {
            //   return parseTime(v[j])
            // } else {
            //   return v[j]
            // }
  
            return v[j]
          })
        )
      },
      get_data() {
        this.loading = true
        var splitted = []

        if (this.teacher_id === null) { this.loading = false; return; }
        if (this.rangeDate === null) {
          splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
          splitted[1] = moment().format("YYYY-MM-DD")
          this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().format("YYYY-MM-DD")
        } else {
          splitted = this.rangeDate.split(" to ");
          if (splitted[1] === undefined) { splitted[1] = splitted[0] }
        }
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/teacher/?teacher_id=` + this.teacher_id.value +`&from=`+splitted[0]+`&to=`+splitted[1])
          .then(res => {
            if (res.data.result === false) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.message,
                },
              })
              this.loading = false
            } else {
              this.items = res.data.classes
              this.stats = res.data.stats
              this.totalRows = this.items.length
              this.loading = false
            }
          })
      },
      get_center_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
          .then(res => {
            this.centerOptions = res.data.centers
          })
      },
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf'
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
      },
      close() {
        this.iframe_src = '//www.cloudfit.pro/invoice.php'
        this.$refs['my-modal'].hide()
        this.clearSelected()
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data(this.searchString)
        }, 500)
      },
    },
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
  <style lang="scss">
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  
  </style>
  